import { render, staticRenderFns } from "./FormSolutionsModal.vue?vue&type=template&id=64b4ecb1&scoped=true&"
import script from "./form-solutions-modal.js?vue&type=script&lang=js&"
export * from "./form-solutions-modal.js?vue&type=script&lang=js&"
import style0 from "./form-solutions-modal.scss?vue&type=style&index=0&id=64b4ecb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b4ecb1",
  null
  
)

export default component.exports